import React, { FC } from 'react';

interface ISearchIconProps {
  className?: string;
  size?: number | string;
}

const SearchIcon: FC<ISearchIconProps> = ({ className, size = '100%' }) => (
  <svg height={size} width={size} viewBox="0 0 14 14" className={className}>
    <path
      d="m10.667 9.655 2.927 2.955a.699.699 0 0 1 -.004.988.686.686 0 0 1 -.97-.005l-2.927-2.955zm-4.744 2.145c-3.271 0-5.923-2.64-5.923-5.9 0-3.258 2.652-5.9 5.923-5.9 3.272 0 5.924 2.642 5.924 5.9 0 3.259-2.652 5.9-5.924 5.9zm0-1.073c2.677 0 4.847-2.16 4.847-4.827 0-2.666-2.17-4.827-4.847-4.827-2.676 0-4.846 2.161-4.846 4.827s2.17 4.827 4.846 4.827z"
      fill="currentColor"
    />
  </svg>
);

export default SearchIcon;
